import useNavigation from "../../../../hooks/navigation";
import type { AccountData } from "../../../../hooks/useAccountTypes";
import { useLogout } from "../../../../hooks/useAuth";
import { useTracker } from "../../../../hooks/useTracker";
import useTranslation from "../../../../hooks/useTranslation";
import { ElementClickAction, ElementClickLocation } from "../../../../lib/TrackingAdapter";
import { AccountButton } from "../AccountButton/AccountButton";
import { MenuPortal } from "../ShareModal/components/MenuPortal";

import style from "./MenuHeader.module.css";

export const MenuHeader = ({
  accountData,
  isCompact = false,
}: {
  accountData?: AccountData;
  isCompact?: boolean;
}) => {
  const { t, m } = useTranslation();
  const tracker = useTracker();
  const navigation = useNavigation();
  const { mutateAsync: mutateLogout, isPending: isLogoutPending } = useLogout({
    redirect: true,
    withRequest: true,
  });
  return (
    <>
      <div className={style.separator} />
      <div className={style.menuContainer}>
        <MenuPortal
          activator={
            <AccountButton name={accountData?.name ?? accountData?.email} isCompact={isCompact} />
          }
          onOpen={() => {
            tracker.trackButtonClick({ action: ElementClickAction.OPEN_ACCOUNT_MENU });
          }}
          onClose={() => {
            tracker.trackButtonClick({ action: ElementClickAction.CLOSE_ACCOUNT_MENU });
          }}
          portalTarget={document.body}
          menuClassName={style.menuDropdown}
        >
          <MenuPortal.Item
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_ACCOUNT_SETTINGS,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
              navigation.goToProfile();
            }}
            closeOnClick
          >
            {t(m.General.AccountSettings)}
          </MenuPortal.Item>
          <MenuPortal.Divider />
          <MenuPortal.Link
            href="https://support.shapr3d.com/hc/en-us"
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_HELP_CENTER,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            {t(m.General.HelpCenter)}
          </MenuPortal.Link>
          <MenuPortal.Link
            href="https://support.shapr3d.com/hc/en-us/articles/12208897524380-Video-tutorials"
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_VIDEO_TUTORIALS,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            {t(m.General.VideoTutorials)}
          </MenuPortal.Link>
          <MenuPortal.Link
            href="https://discourse.shapr3d.com"
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_COMMUNITY,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            {t(m.General.Community)}
          </MenuPortal.Link>
          <MenuPortal.Divider />
          <MenuPortal.Link
            href="https://www.shapr3d.com/download"
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_DOWNLOAD,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            {t(m.General.DownloadShapr3D)}
          </MenuPortal.Link>
          <MenuPortal.Divider />
          <MenuPortal.Item disabled={isLogoutPending} onClick={() => mutateLogout()}>
            {t(m.General.LogOut)}
          </MenuPortal.Item>
        </MenuPortal>
      </div>
    </>
  );
};
